import { Product } from '@/types/product';

interface ContextData {
  product: Pick<Product, 'context_urls'> | null;
  files: unknown[];
  projects: unknown[];
  feedback: unknown[];
  marketResearch: unknown[];
  linkedTools: unknown[];
  experiments: unknown[];
}

export const hasAnyContext = (data: ContextData): boolean => {
  const {
    product,
    files,
    projects,
    feedback,
    marketResearch,
    linkedTools,
    experiments,
  } = data;

  if (!product) {
    return false;
  }

  if (product.context_urls && product.context_urls.length > 0) {
    return true;
  }
  if (files && files.length > 0) {
    return true;
  }

  if (projects && projects.length > 0) {
    return true;
  }

  if (feedback && feedback.length > 0) {
    return true;
  }
  if (marketResearch && marketResearch.length > 0) {
    return true;
  }

  if (linkedTools && linkedTools.length > 0) {
    return true;
  }

  if (experiments && experiments.length > 0) {
    return true;
  }

  return false;
};
